import moment from "moment";

const formatDataHora = (date, replacer = "—") => date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : replacer;

const formatData = (date, replacer = "—") => date ? moment(date).format("DD/MM/YYYY") : replacer;

const getMinDate = (minDays) => {
    const minimalDate = new Date();
    minimalDate.setDate(minimalDate.getDate() - minDays);
    return minimalDate;
}

const getDaysElapsedSince = (date) => {
    const from = new Date(date).getTime();
    const to = Date.now();

    const msPerDay = 1000 * 60 * 60 * 24;
    const diffMs = to - from;

    const days = diffMs / msPerDay;
    return isNaN(days) ? 0 : Math.floor(days);
};

const formatDataHoraMinuto = (date, replacer = "—") => date ? moment(date).format("DD/MM/YYYY HH:mm") : replacer;

export { formatDataHora, formatData, getMinDate, getDaysElapsedSince, formatDataHoraMinuto }